import React from 'react';
import clsx from 'clsx';

interface LoginFormProps {
  onLogin: (credentials: { username: string; password: string }) => Promise<boolean>;
}

export function LoginForm({ onLogin }: LoginFormProps) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    const formData = new FormData(e.target as HTMLFormElement);
    const success = await onLogin({
      username: formData.get('username') as string,
      password: formData.get('password') as string
    });
    
    if (!success) {
      setError('Invalid credentials');
    }
    setIsLoading(false);
  };

  return (
    <div className="w-full max-w-sm space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-white">Welcome Back</h2>
        <p className="mt-2 text-gray-400">Please sign in to continue</p>
      </div>
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username" className="block text-sm font-medium text-gray-300">
            Username
          </label>
          <input
            type="text"
            name="username"
            id="username"
            className="mt-2 block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm px-4 py-3
                     focus:border-red-700 focus:ring-red-700"
            placeholder="Enter your username"
            required
          />
        </div>
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-300">
            Password
          </label>
          <input
            type="password"
            name="password"
            id="password"
            className="mt-2 block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm px-4 py-3
                     focus:border-red-700 focus:ring-red-700"
            placeholder="Enter your password"
            required
          />
        </div>
        {error && (
          <p className="text-red-500 text-sm">{error}</p>
        )}
        <button
          type="submit"
          className={clsx(
            'w-full rounded-md px-4 py-3 text-sm font-medium text-white',
            'bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-2',
            'focus:ring-red-700 focus:ring-offset-2 focus:ring-offset-gray-900',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
          disabled={isLoading}
        >
          {isLoading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}